
/* ============================================================================
   Boars Night Out - Accessibility Remediation (jQuery)
   ----------------------------------------------------------------------------
   Fixes:
     #51 - WCAG 3.3.2 Labels or Instructions .... visible labels for locator fields
     #54 - WCAG 1.4.1 Use of Color ............. "Terms" / "Keyboard shortcuts"
     #57 - WCAG 2.4.7 Focus Visible ............ visible focus for locator controls
     #58 - WCAG 1.4.11 Non-text Contrast ....... 3:1+ focus indicator (dual ring)
     #60 - WCAG 3.3.2 Labels or Instructions .... required-field instructions
     #25 - WCAG 1.4.10 Reflow .................. 400% zoom / 320 CSS px

   Install: Shopify admin > Online Store > Themes > Edit code > layout/theme.liquid
            Paste immediately BEFORE the closing </body> tag.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- jQuery bootstrap ------------------------------------------
     The Storeify locator bundles jQuery 3.7.1 but keeps it out of `window`,
     so this script loads its own copy and immediately calls noConflict(true)
     to leave the global namespace exactly as it found it.                   */
  var JQ_CDN = 'https://code.jquery.com/jquery-3.7.1.min.js';
  var tries  = 0;

  function boot() {
    if (window.jQuery) { return init(window.jQuery); }   /* theme already has it */
    if (++tries > 5) {                                   /* ~1s, then self-host  */
      var s = document.createElement('script');
      s.src = JQ_CDN;
      s.onload = function () {
        var jq = window.jQuery;
        if (jq && jq.noConflict) { jq = jq.noConflict(true); }
        init(jq);
      };
      document.head.appendChild(s);
      return;
    }
    setTimeout(boot, 200);
  }

  /* ======================================================================== */
  function init($) {
    $(function () {

      /* ==================================================================== *
       * 0. Shared stylesheet
       *    - .bno-a11y-label  : visible field labels             (#51)
       *    - .bno-visually-hidden : SR-only text
       *    - dual focus ring  : white + #0A58CA + white          (#57, #58)
       *      White inner/outer halo guarantees >= 3:1 on dark surfaces
       *      (slider track #333, map tiles); the blue band guarantees
       *      >= 3:1 on the white search panel. Measured: 6.44:1 blue on
       *      white, 12.63:1 white on the #333 slider track, and 6.44:1
       *      between the two bands of the ring itself.
       * ==================================================================== */
      var CSS = [
        '.bno-visually-hidden{position:absolute!important;width:1px!important;height:1px!important;',
        'padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;',
        'clip-path:inset(50%)!important;white-space:nowrap!important;border:0!important;}',

        /* ---- #51 visible labels ---- */
        /* site CSS colours/aligns bare labels inside the widget, so scope + !important */
        '.storeifyapps-storelocator-shortcode .bno-a11y-label,.bno-a11y-label{',
        'display:block!important;font-size:14px!important;line-height:1.3!important;',
        'font-weight:600!important;color:#121212!important;margin:0 0 4px!important;',
        'padding:0!important;float:none!important;width:auto!important;',
        'text-align:left!important;text-decoration:none!important;text-transform:none!important;}',
        '.storeifyapps-storelocator-shortcode .search-address-box{display:grid;',
        'grid-template-columns:auto minmax(0,1fr);gap:0 10px;align-items:start;}',
        '.storeifyapps-storelocator-shortcode .search-address-box>*{float:none!important;',
        'width:auto!important;margin-left:0!important;margin-right:0!important;}',
        '.storeifyapps-storelocator-shortcode .bno-field{min-width:0;}',
        '.storeifyapps-storelocator-shortcode .bno-field select{width:100%;}',
        '.storeifyapps-storelocator-shortcode .bno-field[hidden]{display:none!important;}',

        /* ---- #57 + #58 dual-tone focus ring ---- */
        '.storeifyapps-storelocator-shortcode select:focus-visible,',
        '.storeifyapps-storelocator-shortcode input:focus-visible,',
        '.storeifyapps-storelocator-shortcode button:focus-visible,',
        '.storeifyapps-storelocator-shortcode a:focus-visible,',
        '.storeifyapps-storelocator-shortcode [tabindex]:focus-visible,',
        '.gm-style-cc a:focus-visible,.gm-style-cc button:focus-visible{',
        'outline:3px solid transparent!important;',   /* Windows High Contrast */
        'outline-offset:2px!important;',
        'box-shadow:0 0 0 2px #FFFFFF,0 0 0 5px #0A58CA,0 0 0 7px #FFFFFF!important;',
        'border-radius:2px;position:relative;z-index:5;}',

        /* keep the ring off mouse users, but never remove it for keyboard */
        '.storeifyapps-storelocator-shortcode :focus:not(:focus-visible){box-shadow:none;}',

        /* browsers without :focus-visible support */
        '@supports not selector(:focus-visible){',
        '.storeifyapps-storelocator-shortcode select:focus,',
        '.storeifyapps-storelocator-shortcode input:focus,',
        '.storeifyapps-storelocator-shortcode button:focus,',
        '.gm-style-cc a:focus,.gm-style-cc button:focus{',
        'outline:3px solid #0A58CA!important;outline-offset:2px!important;}}',

        /* range input thumb needs its own ring (#57 "progress bar") */
        '.storeifyapps-storelocator-shortcode input[type="range"]:focus-visible::-webkit-slider-thumb{',
        'box-shadow:0 0 0 2px #FFFFFF,0 0 0 5px #0A58CA,0 0 0 7px #FFFFFF;}',
        '.storeifyapps-storelocator-shortcode input[type="range"]:focus-visible::-moz-range-thumb{',
        'box-shadow:0 0 0 2px #FFFFFF,0 0 0 5px #0A58CA,0 0 0 7px #FFFFFF;}',

        /* ---- #54 make map "Terms" / "Keyboard shortcuts" look interactive ---- */
        '.gm-style-cc a,.gm-style-cc button{',
        'text-decoration:underline!important;text-underline-offset:2px!important;',
        'text-decoration-thickness:1px!important;cursor:pointer!important;}',
        '.gm-style-cc a:hover,.gm-style-cc button:hover{',
        'text-decoration-thickness:2px!important;background:#FFFFFF!important;color:#0A58CA!important;}',

        /* ---- #60 required-field instructions ---- */
        '.bno-required-note{display:block;font-size:15px;line-height:1.5;color:#121212;',
        'margin:0 0 1rem;}',
        '.bno-required-note .bno-star{color:#B3261E;font-weight:700;}',

        /* ---- #25 Reflow at 400% zoom (= a 320 CSS px viewport) ---- */

        /* a) Hidden labels must not rely on the deprecated `clip` alone.
              base.css has `.header__icon span{height:100%}`, which beats
              `.visually-hidden{height:1px}` on specificity and stretches the
              "Log in" / "Cart" labels into a 1x145px box (1x426px on mobile)
              sitting directly over the header icons. The moment anything
              neutralises `clip` the text paints. `:not(:focus...)` keeps the
              skip-to-content link free to reveal itself. */
        '.visually-hidden:not(:focus):not(:focus-within):not(:active){',
        'clip-path:inset(50%)!important;white-space:nowrap!important;',
        'overflow:hidden!important;}',
        '.header__icon span.visually-hidden{width:1px!important;height:1px!important;}',

        '@media screen and (max-width:749px){',
        /* b) The banner had a fixed 280px height with object-fit:cover, so it
              cropped ~26% of the image at 406px and ~42% at 320px - and the
              product names are baked into the artwork. Honour the image's own
              ratio instead; --bno-banner-ratio is set from the img attrs. */
        '.banner{height:auto!important;aspect-ratio:var(--bno-banner-ratio,16/9);}',
        '.banner__content{min-height:0!important;}',
        '.banner__media{height:100%!important;}',
        '.banner__media img{width:100%!important;height:100%!important;}',

        /* c) The floating hCaptcha badge is position:fixed, 223px wide and
              parked past the right edge - at 320px it and its Privacy /
              Terms links are 167px outside the viewport and unreachable.
              Hidden here and replaced with the in-flow disclosure below,
              which is hCaptcha's documented alternative to the badge. */
        // '#shop-hcaptcha-badge-container{display:none!important;}',

        /* d) nothing else may exceed the viewport width */
        '.search__input,.field__input{max-width:100%!important;}',
        '}',

        '.bno-captcha-notice{display:block;margin:1.2rem 0 0;padding:0 1.5rem 1.5rem;',
        'font-size:1.3rem;line-height:1.5;text-align:center;opacity:.85;}',
        '.bno-captcha-notice a{color:inherit;text-decoration:underline;',
        'text-underline-offset:2px;}'
      ].join('');

      $('<style id="bno-a11y-css">').text(CSS).appendTo('head');

      /* ==================================================================== *
       * ISSUE #51 - WCAG 3.3.2  Visible labels for the store-locator fields
       * ==================================================================== */
      /* Attach a VISIBLE label to a field.
         The Storeify app renders the locator twice (inline + hidden modal),
         which duplicates ids such as #address. A <label for> can only bind to
         the first match, so when the id is not unique we emit a <span> and
         bind it with aria-labelledby instead - visible text either way.      */
      var uid = 0;
      function labelField($field, text, $insertBefore) {
        if (!$field.length || $field.data('bnoLabelled')) { return; }
        $field.data('bnoLabelled', true);

        var id = $field.attr('id');
        var unique = id && $('[id="' + id + '"]').length === 1;
        var $label;

        if (unique) {
          $label = $('<label class="bno-a11y-label">').attr('for', id).text(text);
        } else {
          var lid = 'bno-lbl-' + (++uid);
          $label = $('<span class="bno-a11y-label">').attr('id', lid).text(text);
          $field.attr('aria-labelledby', lid);
        }
        ($insertBefore && $insertBefore.length ? $insertBefore : $field).before($label);
        return $label;
      }

      function addVisibleLabels() {
        $('.storeifyapps-storelocator-shortcode').each(function () {
          var $root = $(this);
          var $box  = $root.find('.search-address-box').first();
          if (!$box.length || $box.data('bnoDone')) { return; }
          $box.data('bnoDone', true);

          /* 1. "Location / Store name" <select> - shipped with no id, no label */
          var $select = $box.find('select.chose-search-slt').first();
          if ($select.length) {
            $select.wrap('<div class="bno-field bno-field--type"></div>');
            labelField($select, 'Search by');
          }

          /* 2. Address input - only had placeholder "Type to search our stores" */
          var $addr = $box.find('input[name="address"]').first();
          if ($addr.length) {
            labelField($addr, 'Search our stores');
          }

          /* 3. Store-name input (shown when "Store name" is selected) --------- */
          var $store = $box.find('input[name="store_search"]').first();
          if ($store.length) {
            $store.wrap('<div class="bno-field bno-field--store"></div>');
            labelField($store, 'Store name');

            /* the app toggles the field with an inline display style - keep the
               visible label in step so it never outlives its field           */
            var $wrap = $store.closest('.bno-field');
            var sync  = function () {
              $wrap.prop('hidden', $store.css('display') === 'none');
            };
            sync();
            if (window.MutationObserver) {
              new MutationObserver(sync).observe($store[0], {
                attributes: true, attributeFilter: ['style', 'class']
              });
            }
            $root.on('change', 'select.chose-search-slt', function () {
              setTimeout(sync, 50);
            });
          }

          /* 4. Radius slider - a <label> existed but was never associated ----- */
          var $radius = $root.find('input[name="points"]').first();
          if ($radius.length && !$radius.data('bnoRadius')) {
            $radius.data('bnoRadius', true);
            var rid = $radius.attr('id');
            var $rl = $radius.closest('.search-radius-box').find('label').first();
            if ($rl.length && !$rl.attr('for') && rid && $('[id="' + rid + '"]').length === 1) {
              $rl.attr('for', rid);
            }
            $radius.attr('aria-valuetext', $radius.val() + ' miles')
                   .on('input change', function () {
                     $(this).attr('aria-valuetext', this.value + ' miles');
                   });
            if (!$radius.attr('aria-label') && !$rl.attr('for')) {
              $radius.attr('aria-label', 'Search radius in miles');
            }
          }
        });
      }

      /* ==================================================================== *
       * ISSUE #54 - WCAG 1.4.1  "Terms" / "Keyboard shortcuts" distinction
       * The CSS above does the styling; Google re-renders these controls on
       * map init / resize, so re-assert nothing is needed for CSS, but we do
       * give the controls a proper accessible name where one is missing.
       * ==================================================================== */
      function fixMapControls() {
        $('.gm-style-cc').find('a, button').each(function () {
          var $c = $(this);
          var txt = $.trim($c.text());
          if (txt && !$c.attr('aria-label')) { $c.attr('aria-label', txt); }
          /* links that open a new tab should say so */
          if (this.tagName === 'A' && $c.attr('target') === '_blank' &&
              $c.find('.bno-visually-hidden').length === 0) {
            $c.append('<span class="bno-visually-hidden"> (opens in a new tab)</span>');
          }
        });
      }

      /* ==================================================================== *
       * ISSUE #57 / #58 - Focus visibility + contrast
       * Handled by the stylesheet. Here we only make sure every locator
       * control is actually reachable and not focus-trapped by tabindex="-1".
       * ==================================================================== */
      function fixFocusability() {
        $('.storeifyapps-storelocator-shortcode')
          .find('#submit-search, #getbylocal, #btn-filter, .map-tab-mobile-bnt-item')
          .each(function () {
            var $el = $(this);
            if (this.tagName === 'DIV') {          /* app uses <div> as buttons */
              if (!$el.attr('role'))     { $el.attr('role', 'button'); }
              if (!$el.attr('tabindex')) { $el.attr('tabindex', '0'); }
              if (!$el.data('bnoKeys')) {
                $el.data('bnoKeys', true).on('keydown', function (e) {
                  if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                    e.preventDefault();
                    $(this).trigger('click');
                  }
                });
              }
            }
            if ($el.attr('tabindex') === '-1') { $el.attr('tabindex', '0'); }
          });
      }

      /* ==================================================================== *
       * BONUS - icon ligatures were part of the accessible name
       * The locator buttons render Material Icons as text ("travel_explore
       * Search"), so JAWS announced the ligature. Hide the glyph from AT and
       * fall back to the button's own title when nothing readable is left.
       * ==================================================================== */
      function fixIconButtons() {
        $('.storeifyapps-storelocator-shortcode')
          .find('.material-icons, .material-icons-outlined')
          .attr('aria-hidden', 'true');

        $('.storeifyapps-storelocator-shortcode').find('button, [role="button"]').each(function () {
          var $b = $(this);
          var visible = $.trim($b.clone().find('[aria-hidden="true"]').remove().end().text());
          if (!visible && !$b.attr('aria-label')) {
            $b.attr('aria-label', $b.attr('title') || 'Button');
          }
        });
      }

      /* ==================================================================== *
       * ISSUE #60 - WCAG 3.3.2  Required-field instructions (Contact form)
       * Also applied to any Shopify form that uses "*" in its labels
       * (contact, login, "Continue with Shop" email step).
       * ==================================================================== */
      function addRequiredInstructions() {
        $('form').each(function () {
          var $form = $(this);
          if ($form.data('bnoReq')) { return; }

          /* find labels whose visible text ends with an asterisk */
          var $starLabels = $form.find('label').filter(function () {
            return /\*\s*$/.test($(this).text());
          });
          if (!$starLabels.length) { return; }
          $form.data('bnoReq', true);

          /* 1. visible instruction, announced before the first field -------- */
          var noteId = 'bno-required-note-' + ($form.attr('id') || Math.random().toString(36).slice(2, 7));
          var $note = $('<p class="bno-required-note">')
            .attr('id', noteId)
            .html('Fields marked with an asterisk ' +
                  '<span class="bno-star" aria-hidden="true">(*)</span> are required.');

          /* put the instruction ABOVE the very first field of the form, so it
             is read before the user reaches any control (3.3.2)            */
          var $anchor = $form.find('.field, .form__group, .contact__fields').first();
          if (!$anchor.length) {
            $anchor = $form.find('input:not([type=hidden]),select,textarea').first()
                           .closest('div');
          }
          if ($anchor.length) { $note.insertBefore($anchor); }
          else { $form.prepend($note); }

          /* 2. programmatic required state + description -------------------- */
          $starLabels.each(function () {
            var $lab = $(this);
            var id = $lab.attr('for');
            var $field = id ? $('#' + window.CSS.escape(id)) : $lab.find('input,select,textarea').first();
            if (!$field.length) { return; }

            $field.attr({ 'aria-required': 'true' });

            var desc = ($field.attr('aria-describedby') || '').split(/\s+/).filter(Boolean);
            if (desc.indexOf(noteId) === -1) { desc.push(noteId); }
            $field.attr('aria-describedby', desc.join(' '));

            /* 3. the asterisk must not be the only cue in the accessible name.
                  Dawn already wraps it in aria-hidden, so only add the spoken
                  word; a bare "*" gets wrapped as well.                      */
            if (!$lab.data('bnoStar')) {
              $lab.data('bnoStar', true);
              var html = $lab.html();
              if (/\*(\s*)$/.test(html)) {
                $lab.html(html.replace(
                  /\*(\s*)$/,
                  '<span class="bno-star" aria-hidden="true">*</span>' +
                  '<span class="bno-visually-hidden"> (required)</span>$1'
                ));
              } else if (!$lab.find('.bno-visually-hidden').length) {
                $lab.append('<span class="bno-visually-hidden"> (required)</span>');
              }
            }
          });
        });
      }

      /* ==================================================================== *
       * ISSUE #25 - WCAG 1.4.10 Reflow
       * The stylesheet above does the layout work. Two things need JS:
       * the banner's real aspect ratio, and an in-flow replacement for the
       * hCaptcha badge that is hidden on narrow viewports.
       * ==================================================================== */
      function fixBannerRatio() {
        $('.banner').each(function () {
          var $b = $(this);
          if ($b.data('bnoRatio')) { return; }
          var img = $b.find('.banner__media img')[0];
          if (!img) { return; }
          var w = parseFloat(img.getAttribute('width'))  || img.naturalWidth;
          var h = parseFloat(img.getAttribute('height')) || img.naturalHeight;
          if (!w || !h) { return; }
          $b.data('bnoRatio', true);
          $b[0].style.setProperty('--bno-banner-ratio', w + ' / ' + h);
        });
      }

      // function addCaptchaNotice() {
      //   if ($('.bno-captcha-notice').length) { return; }
      //   /* Shopify loads the badge lazily, so key off the forms hCaptcha
      //      actually protects (newsletter, contact, account) - or the badge
      //      itself once it appears. Never claim protection otherwise. */
      //   var protectedForm = $('form[action*="/contact"], form[action*="/account"], form[action*="/comments"]').length;
      //   if (!protectedForm && !document.getElementById('shop-hcaptcha-badge-container')) { return; }

      //   var $host = $('.footer__content-bottom').first();
      //   if (!$host.length) { $host = $('.footer').first(); }
      //   if (!$host.length) { return; }

      //   $host.append(
      //     '<p class="bno-captcha-notice">This site is protected by hCaptcha and its ' +
      //     '<a href="https://hcaptcha.com/privacy" target="_blank" rel="noopener">Privacy Policy' +
      //     '<span class="bno-visually-hidden"> (opens in a new tab)</span></a> and ' +
      //     '<a href="https://hcaptcha.com/terms" target="_blank" rel="noopener">Terms of Service' +
      //     '<span class="bno-visually-hidden"> (opens in a new tab)</span></a> apply.</p>'
      //   );
      // }

      /* ==================================================================== *
       * Run now, and again as the Storeify app / Google Maps finish painting
       * ==================================================================== */
      function runAll() {
        try { addVisibleLabels(); }        catch (e) { }
        try { fixMapControls(); }          catch (e) { }
        try { fixFocusability(); }         catch (e) { }
        try { fixIconButtons(); }          catch (e) { }
        try { addRequiredInstructions(); } catch (e) { }
        try { fixBannerRatio(); }          catch (e) { }
        // try { addCaptchaNotice(); }        catch (e) { }
      }

      runAll();
      [300, 800, 1500, 3000, 5000].forEach(function (t) { setTimeout(runAll, t); });

      if (window.MutationObserver) {
        var pending;
        new MutationObserver(function () {
          clearTimeout(pending);
          pending = setTimeout(runAll, 250);
        }).observe(document.body, { childList: true, subtree: true });
      }
    });
  }

  boot();
})();


/*!
 * a11y-textcard-fix.js  (v2.1)
 * Remediation for Shopify Dawn product cards that have NO featured image
 * (Dawn renders these as `.card.card--standard.card--text`).
 *
 * Bug 1 - the card link is not clickable
 *   Dawn stacks TWO absolutely positioned layers on a text-only card:
 *     .card__inner > .card__content   -> the real <a> product title
 *     .card       > .card__content    -> inset:0 overlay holding the price
 *   The price overlay is a later sibling with position:absolute, so it paints
 *   over the title link's ::after hit area. Pointer clicks land on a plain
 *   <div>: the card looks like a link and behaves like dead space. (Keyboard
 *   users can still reach the <a>, which is why it only breaks for the mouse.)
 *
 * Bug 2 - title and price overlap as text reflows
 *   Both layers are independently centred on the same square, so the title
 *   grows out of its own centre straight through the price. Visible from
 *   ~890px wide at 100% zoom, 42px of collision at 175%.
 *   Fails WCAG 2.2 SC 1.4.4 Resize Text and SC 1.4.10 Reflow.
 *
 * Fix - give the text card the same box model as an image card:
 *   placeholder square on top (title centred inside, sold-out badge bottom
 *   left), then the price in the normal flow row underneath, aligned to the
 *   card's leading edge exactly like an image card's. Nothing is
 *   absolutely positioned over anything else, so the two defects cannot recur,
 *   and the grid reads as one consistent row. No DOM is moved and no second
 *   link is introduced.
 *
 * Load AFTER jQuery. Safe to run more than once.
 */
(function ($) {
  'use strict';

  if (!$) { return; }

  var STYLE_ID = 'a11y-textcard-css';
  var FIXED    = 'a11y-textcard';

  var CSS = [
    /* Column layout: placeholder square, then the text row - same as an image card. */
    '.' + FIXED + '{position:relative;display:flex;flex-direction:column;}',

    /* Placeholder square. The fixed aspect-ratio spacer is replaced by a
       min-height so the box keeps its shape but can still grow when text
       reflows at high zoom instead of trapping it. */
    '.' + FIXED + ' .card__inner.ratio::before{content:none !important;}',
    '.' + FIXED + ' .card__inner{position:relative;flex:0 0 auto;height:auto !important;'
      + 'min-height:var(--a11y-textcard-minh,0px);align-items:center;justify-content:center;}',

    /* The title layer joins normal flow instead of floating over the card. */
    '.' + FIXED + ' .card__inner > .card__content{position:static !important;height:auto !important;'
      + 'width:100%;flex:1 1 auto;align-self:stretch;display:flex;flex-direction:column;'
      + 'align-items:center;justify-content:flex-start;}',
    '.' + FIXED + ' .card__inner .card__information{display:block;width:auto;max-width:100%;'
      + 'margin-block:auto;}',
    '.' + FIXED + ' .card__inner .card__heading{margin:0;overflow-wrap:anywhere;}',

    /* Sold-out badge sits bottom left of the placeholder, where the image cards
       put theirs. In flow, so a long title can never collide with it. */
    '.' + FIXED + ' .card__inner .card__badge{align-self:flex-start;margin:0;}',

    /* Price row: the same flow row the image cards use, no longer an overlay. */
    '.' + FIXED + ' > .card__content{position:static !important;display:grid !important;'
      + 'height:auto !important;justify-content:normal !important;justify-items:stretch;}',
    /* Dawn centres every part of a text card. Only the placeholder square keeps
       that; the price lines up with the card's leading edge, like image cards. */
    '.' + FIXED + ' > .card__content .card__information{text-align:start !important;'
      + 'width:100%;}',
    /* The theme already ships a hidden copy of the title in this row. Rendering
       it invisibly reserves the line the image cards use for their title, so
       every price in a row shares one baseline. visibility:hidden keeps it out
       of the accessibility tree and out of the tab order. */
    '.' + FIXED + ' > .card__content .card__heading{display:block !important;visibility:hidden;}',

    /* Link hit area covers the whole card, exactly as it does on image cards. */
    '.' + FIXED + ' .card__inner .card__heading a::after{'
      + 'bottom:calc(-1 * var(--a11y-textcard-below,0px));z-index:2;}',

    /* Visible, non-clipped focus indicator - WCAG 2.2 SC 2.4.11 / 2.4.13. */
    '.' + FIXED + ' .card__inner .card__heading a:focus-visible::after{'
      + 'outline:3px solid currentColor;outline-offset:-3px;border-radius:inherit;}',
    '.' + FIXED + ' .card__inner .card__heading a:focus-visible{outline:none;}'
  ].join('\n');

  function injectCss() {
    if (document.getElementById(STYLE_ID)) { return; }
    $('<style>', { id: STYLE_ID, type: 'text/css' }).text(CSS).appendTo('head');
  }

  /* --a11y-textcard-minh keeps the placeholder square at its original aspect.
     --a11y-textcard-below extends the link's hit area over the price row. */
  function measure(card) {
    var $card  = $(card);
    var $inner = $card.children('.card__inner').first();
    if (!$inner.length) { return; }

    var ratio = $inner.data('a11yRatio');
    var w = $inner.outerWidth();
    if (!ratio) {
      var h = $inner.outerHeight();
      if (!w || !h) { return; }
      ratio = h / w;
      $inner.data('a11yRatio', ratio);
    }
    if (w) {
      $inner[0].style.setProperty('--a11y-textcard-minh', Math.round(w * ratio) + 'px');
    }
    card.style.setProperty(
      '--a11y-textcard-below',
      Math.round($card.children('.card__content').outerHeight() || 0) + 'px'
    );
  }

  var ro = window.ResizeObserver ? new ResizeObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var card = entries[i].target.parentElement;
      if (card && card.classList.contains(FIXED)) { measure(card); }
    }
  }) : null;

  function repairCard(card) {
    var $card = $(card);
    if ($card.hasClass(FIXED)) { return; }

    var $inner = $card.children('.card__inner').first();
    var $row   = $card.children('.card__content').first();
    if (!$inner.length || !$row.length) { return; }

    /* Record the original square before the new rules change its height. */
    var w = $inner.outerWidth();
    var h = $inner.outerHeight();
    $inner.data('a11yRatio', (w && h) ? h / w : 1);

    /* The spacer copy of the title must not be reachable. visibility:hidden
       already does this; tabindex is belt and braces for older engines. */
    $row.find('.card__heading a').attr('tabindex', '-1');

    $card.addClass(FIXED);
    measure(card);

    if (ro) { ro.observe($row[0]); }
  }

  /* Safety net for theme variants that still park something over the link.
     Mouse convenience only - the real <a> handles keyboard, Enter,
     middle-click and "open in new tab". */
  function bindClickFallback() {
    $(document)
      .off('click.a11yTextcard')
      .on('click.a11yTextcard', '.' + FIXED, function (event) {
        if ($(event.target).closest('a[href], button, input, select, textarea, label').length) { return; }
        if (event.which > 1 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) { return; }
        var sel = window.getSelection && window.getSelection();
        if (sel && String(sel).length) { return; }   // don't hijack text selection
        var href = $(this).find('.card__inner .card__heading a[href]').attr('href');
        if (href) { window.location.href = href; }
      });
  }

  function run() {
    injectCss();
    $('.card.card--text').each(function () { repairCard(this); });
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      $('.' + FIXED).each(function () { measure(this); });
    }, 150);
  }

  $(function () {
    run();
    bindClickFallback();
    $(window).on('resize.a11yTextcard orientationchange.a11yTextcard load.a11yTextcard', onResize);

    /* Re-run for cards injected later: theme editor, facet filters, pagination,
       predictive search, infinite scroll. */
    $(document).on('shopify:section:load shopify:section:reorder ajaxComplete', run);
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          if (records[i].addedNodes.length) { run(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  });

  window.a11yTextcardFix = { run: run, measure: measure };
}(window.jQuery));

/*!
 * a11y-captcha-links.js
 * Underlines the Privacy / Terms links in the captcha badge, and makes the
 * badge usable from the keyboard.
 *
 * Context
 *   This store's captcha is hCaptcha, injected by Shopify only after the
 *   visitor first interacts with a form field. The badge is rendered into the
 *   TOP-LEVEL document as:
 *
 *     <div id="shop-hcaptcha-badge-container">
 *       <img>
 *       <div class="info">
 *         <span>Protected by hCaptcha</span>
 *         <ul class="links">
 *           <li><a class="privacy" target="_blank">Privacy</a></li>
 *           <li><a class="terms"   target="_blank">Terms</a></li>
 *         </ul>
 *       </div>
 *     </div>
 *
 *   Because it is in the page (not in the captcha's cross-origin iframe) it can
 *   be styled. NOTE: the "Privacy - Terms" text inside the hCaptcha *challenge*
 *   iframe, and inside a Google `.grecaptcha-badge`, lives in a cross-origin
 *   document and cannot be reached by any CSS or script on this page.
 *
 * What this fixes
 *   1. SC 1.4.1 Use of Color - "Privacy" and "Terms" were rendered in exactly
 *      the same white as the surrounding "Protected by hCaptcha" text with
 *      text-decoration:none, so nothing identified them as links. Now underlined.
 *   2. SC 2.4.11 Focus Not Obscured (Minimum) - the badge is position:fixed at
 *      right:-167px and only slides in on :hover, so a keyboard user tabbing to
 *      "Privacy" focused a control sitting entirely outside the viewport.
 *      :focus-within now brings it on screen. (Remove that rule if you only
 *      want the underline.)
 *   3. The links open in a new tab with no warning and no rel - now announced
 *      with visually hidden text, matching the wording already used by
 *      .bno-captcha-notice in the footer, plus rel="noopener noreferrer".
 *
 * STILL OPEN (not changed here - it is hCaptcha's brand styling, decide before
 * touching): the badge renders #FFFFFF text on #00ABBF at 10px, which is
 * 2.77:1 and fails SC 1.4.3 Contrast (Minimum). 4.5:1 needs roughly #005E69
 * or darker behind white text.
 *
 * Load AFTER jQuery. Safe to run more than once.
 */
(function ($) {
  'use strict';

  if (!$) { return; }

  /* Set to false to leave the accessible names untouched. */
  var ANNOUNCE_NEW_TAB = true;
  var NEW_TAB_TEXT     = '(opens in a new tab)';

  var STYLE_ID = 'a11y-captcha-links-css';
  var HIDDEN   = 'a11y-visually-hidden';
  var DONE     = 'a11y-captcha-link';

  /* Same-document captcha containers. Anything inside a cross-origin captcha
     iframe is out of reach and is not covered by these. */
  var SCOPES = [
    '#shop-hcaptcha-badge-container',
    '.h-captcha',
    '.shopify-challenge__container'
  ];

  function each(suffix) {
    return SCOPES.map(function (s) { return s + ' ' + suffix; }).join(',');
  }

  var CSS = [
    /* 1. SC 1.4.1 - links must not rely on colour alone. */
    each('a') + '{text-decoration:underline !important;text-underline-offset:2px;}',
    each('a:hover') + ',' + each('a:focus-visible')
      + '{text-decoration-thickness:2px !important;}',

    /* 2. SC 2.4.11 - keep the fixed badge on screen while it holds focus. */
    '#shop-hcaptcha-badge-container:focus-within{right:0 !important;left:auto !important;}',

    /* Visible focus indicator - SC 2.4.7 / 2.4.13. */
    each('a:focus-visible') + '{outline:2px solid currentColor;outline-offset:2px;}',

    /* 3. Visually hidden helper. The badge styles its own spans with ID-level
       specificity, so every declaration has to be !important here. */
    '.' + HIDDEN + '{position:absolute !important;width:1px !important;height:1px !important;'
      + 'margin:-1px !important;padding:0 !important;overflow:hidden !important;'
      + 'clip:rect(0 0 0 0) !important;clip-path:inset(50%) !important;'
      + 'white-space:nowrap !important;border:0 !important;float:none !important;}'
  ].join('\n');

  function injectCss() {
    if (document.getElementById(STYLE_ID)) { return; }
    $('<style>', { id: STYLE_ID, type: 'text/css' }).text(CSS).appendTo('head');
  }

  function enhanceLinks() {
    $(SCOPES.join(',')).find('a[href]').each(function () {
      var $a = $(this);
      if ($a.hasClass(DONE)) { return; }
      $a.addClass(DONE);

      if ($a.attr('target') === '_blank') {
        var rel = $.trim($a.attr('rel') || '');
        if (!/\bnoopener\b/.test(rel)) {
          $a.attr('rel', $.trim(rel + ' noopener noreferrer'));
        }
        if (ANNOUNCE_NEW_TAB && !$a.find('.' + HIDDEN).length) {
          $a.append(' <span class="' + HIDDEN + '">' + NEW_TAB_TEXT + '</span>');
        }
      }
    });
  }

  function run() {
    injectCss();
    enhanceLinks();
  }

  $(function () {
    run();

    /* The badge is injected only after the visitor touches a form field, and
       hCaptcha may re-render it, so keep watching. */
    if (window.MutationObserver) {
      var pending;
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          if (records[i].addedNodes.length) {
            clearTimeout(pending);
            pending = setTimeout(run, 50);
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    /* Belt and braces for themes that load the captcha on submit. */
    $(document).on('focusin.a11yCaptcha', 'form', function () { setTimeout(run, 800); });
  });

  window.a11yCaptchaLinks = { run: run };
}(window.jQuery));



// testing 400%

/* ==========================================================================
   Boars Night Out — floating widget reflow remediation (behaviour)
   Pairs with floating-widgets-reflow.css

   NOTE ON jQUERY: this page does not load jQuery (window.jQuery is
   undefined on boarsnightout.com). This script is therefore dependency-free
   so it can be dropped into theme.liquid or an overlay script without
   pulling ~30KB of library in just to move three nodes. If your remediation
   pipeline already guarantees jQuery, the DOM calls map 1:1
   ($('#id'), .appendTo(), .on('click'), .attr('aria-expanded')).

   What it does, at viewports <= 640px wide or <= 480px tall:
     1. Re-parents the three floating widgets into a single #a11yDock.
     2. Ships the dock collapsed behind one 44x44 labelled toggle, so no
        page content is covered until the user asks for it  (SC 1.4.10).
     3. Keeps every widget reachable and visible when expanded, laid out in
        a spaced column with no mutual overlap  (SC 2.5.8).
     4. Auto-collapses if keyboard focus lands on page content that the
        expanded panel would obscure  (SC 2.4.11 Focus Not Obscured (Min)).
     5. Restores the widgets to their original DOM position when the
        viewport goes back above the breakpoint, so desktop is untouched.
   ========================================================================== */

(function () {
  'use strict';

  var BREAKPOINT = '(max-width: 640px), (max-height: 480px)';

  /* Ordered top -> bottom in the expanded column. */
  var WIDGETS = [
    { id: 'shop-hcaptcha-badge-container', label: 'hCaptcha badge' },
    { id: 'accessiblyAppWidgetButton',     label: 'Accessibility options' },
    { id: 'storeify-sl-btn-trigger-popup', label: 'Store locator' }
  ];

  var TOGGLE_LABEL_OPEN  = 'Show site tools (accessibility, store locator)';
  var TOGGLE_LABEL_CLOSE = 'Hide site tools';

  var dock, panel, toggle;
  var homes = {};        /* id -> { parent, nextSibling } for restore */
  var docked = false;

  /* ---------------------------------------------------------------- utils */

  function byId(id) { return document.getElementById(id); }

  function build() {
    if (dock) { return; }

    dock = document.createElement('div');
    dock.id = 'a11yDock';

    panel = document.createElement('div');
    panel.id = 'a11yDockPanel';
    panel.hidden = true;

    toggle = document.createElement('button');
    toggle.id = 'a11yDockToggle';
    toggle.type = 'button';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', 'a11yDockPanel');
    toggle.setAttribute('aria-label', TOGGLE_LABEL_OPEN);
    toggle.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M6 15l6-6 6 6"/></svg>' +
      '<span class="a11y-dock-sr">Site tools</span>';

    toggle.addEventListener('click', function () {
      setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
    });

    dock.appendChild(panel);
    dock.appendChild(toggle);
    document.body.appendChild(dock);
  }

  function setExpanded(open) {
    if (!toggle) { return; }
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? TOGGLE_LABEL_CLOSE : TOGGLE_LABEL_OPEN);
    panel.hidden = !open;
  }

  function isExpanded() {
    return !!toggle && toggle.getAttribute('aria-expanded') === 'true';
  }

  /* --------------------------------------------------------- dock/undock */

  function dockWidgets() {
    build();

    WIDGETS.forEach(function (spec) {
      var el = byId(spec.id);
      if (!el || el.parentNode === panel) { return; }

      /* Remember where it came from so desktop can be restored exactly. */
      homes[spec.id] = { parent: el.parentNode, next: el.nextSibling };

      /* Some apps write position:fixed inline; the stylesheet overrides it,
         but clear the inline offsets too so nothing fights the flex column. */
      ['top', 'right', 'bottom', 'left', 'transform'].forEach(function (p) {
        el.style.removeProperty(p);
      });

      if (!el.getAttribute('aria-label') && !el.textContent.trim()) {
        el.setAttribute('aria-label', spec.label);
      }

      panel.appendChild(el);
    });

    document.body.classList.add('a11y-dock-ready');
    docked = true;   /* re-entrant: late-arriving widgets are picked up above */
  }

  function undockWidgets() {
    if (!docked) { return; }

    WIDGETS.forEach(function (spec) {
      var el = byId(spec.id);
      var home = homes[spec.id];
      if (!el || !home || !home.parent) { return; }
      if (home.next && home.next.parentNode === home.parent) {
        home.parent.insertBefore(el, home.next);
      } else {
        home.parent.appendChild(el);
      }
    });

    homes = {};
    setExpanded(false);
    document.body.classList.remove('a11y-dock-ready');
    docked = false;
  }

  /* --------------------------- SC 2.4.11 Focus Not Obscured (Minimum) ---- */

  function overlaps(a, b) {
    return !(a.bottom <= b.top || a.top >= b.bottom ||
             a.right <= b.left || a.left >= b.right);
  }

  document.addEventListener('focusin', function (e) {
    if (!docked || !isExpanded()) { return; }
    if (dock.contains(e.target)) { return; }

    var target = e.target.getBoundingClientRect();
    if (!target.width && !target.height) { return; }

    if (overlaps(target, dock.getBoundingClientRect())) {
      /* The panel would sit on top of what the user just focused. Collapse
         it rather than let the widget hide the focus indicator. */
      setExpanded(false);
      if (typeof e.target.scrollIntoView === 'function') {
        e.target.scrollIntoView({ block: 'nearest' });
      }
    }
  }, true);

  /* Escape closes the panel and returns focus to the toggle. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') { return; }
    if (!docked || !isExpanded()) { return; }
    if (!dock.contains(document.activeElement)) { return; }
    setExpanded(false);
    toggle.focus();
  });

  /* ----------------------------------------------------------- lifecycle */

  function sync(mq) {
    if (mq.matches) { dockWidgets(); } else { undockWidgets(); }
  }

  function init() {
    var mq = window.matchMedia(BREAKPOINT);
    sync(mq);

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', sync);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(sync);          /* Safari < 14 */
    }

    /* The three widgets are injected asynchronously by their apps, so watch
       for late arrivals and pull them in as soon as they appear. */
    var pending = WIDGETS.filter(function (s) { return !byId(s.id); });
    if (!pending.length) { return; }

    var observer = new MutationObserver(function () {
      if (WIDGETS.every(function (s) { return byId(s.id); })) {
        observer.disconnect();
      }
      if (mq.matches) { dockWidgets(); }
    });
    observer.observe(document.body, { childList: true, subtree: false });

    /* Stop watching after 15s regardless — apps that never load stay absent. */
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


// after 50 bug id 

/* ============================================================================
   Boars Night Out - Accessibility Remediation (jQuery)
   ----------------------------------------------------------------------------
   Fixes:
     #51 - WCAG 3.3.2 Labels or Instructions .... visible labels for locator fields
     #54 - WCAG 1.4.1 Use of Color ............. "Terms" / "Keyboard shortcuts"
     #57 - WCAG 2.4.7 Focus Visible ............ visible focus for locator controls
     #58 - WCAG 1.4.11 Non-text Contrast ....... 3:1+ focus indicator (dual ring)
     #60 - WCAG 3.3.2 Labels or Instructions .... required-field instructions
     #25 - WCAG 1.4.10 Reflow .................. 400% zoom / 320 CSS px
     #52 - WCAG 4.1.2 Name, Role, Value ........ "Keyboard shortcuts" twice
     #53 - WCAG 4.1.2 Name, Role, Value ........ combobox has no name
     #55 - WCAG 2.4.3 Focus Order .............. map frame reached second
     #56 - WCAG 2.4.4 Link Purpose ............. raw URL as link text
     #59 - Best practice ....................... Contact page has no <h1>
     #61 - WCAG 2.4.3 Focus Order .............. focus after a failed submit
     #62 - WCAG 1.3.1 Info and Relationships ... one-item error <ul>
     #63 - WCAG 4.1.3 Status Messages .......... success not announced
     #64 - WCAG 1.3.1 Info and Relationships ... redundant hidden heading
     #65 - Best practice ....................... About page has no <h1>
     #66 - WCAG 2.4.4 Link Purpose ............. raw URLs in the policy
     #67 - Best practice ....................... new-tab links not announced
     #68 - WCAG 1.3.1 Info and Relationships ... policy tables, no caption
     #69 - WCAG 2.1.1 Keyboard ................. a11y panel scroll regions
     #70 - WCAG 2.4.3 Focus Order .............. a11y dialog initial focus
     #71 - WCAG 1.4.12 Text Spacing ............ a11y dialog header overlap

   Install: Shopify admin > Online Store > Themes > Edit code > layout/theme.liquid
            Paste immediately BEFORE the closing </body> tag.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- jQuery bootstrap ------------------------------------------
     The Storeify locator bundles jQuery 3.7.1 but keeps it out of `window`,
     so this script loads its own copy and immediately calls noConflict(true)
     to leave the global namespace exactly as it found it.                   */
  var JQ_CDN = 'https://code.jquery.com/jquery-3.7.1.min.js';
  var tries  = 0;

  function boot() {
    if (window.jQuery) { return init(window.jQuery); }   /* theme already has it */
    if (++tries > 5) {                                   /* ~1s, then self-host  */
      var s = document.createElement('script');
      s.src = JQ_CDN;
      s.onload = function () {
        var jq = window.jQuery;
        if (jq && jq.noConflict) { jq = jq.noConflict(true); }
        init(jq);
      };
      document.head.appendChild(s);
      return;
    }
    setTimeout(boot, 200);
  }

  /* ======================================================================== */
  function init($) {
    $(function () {

      /* ==================================================================== *
       * 0. Shared stylesheet
       *    - .bno-a11y-label  : visible field labels             (#51)
       *    - .bno-visually-hidden : SR-only text
       *    - dual focus ring  : white + #0A58CA + white          (#57, #58)
       *      White inner/outer halo guarantees >= 3:1 on dark surfaces
       *      (slider track #333, map tiles); the blue band guarantees
       *      >= 3:1 on the white search panel. Measured: 6.44:1 blue on
       *      white, 12.63:1 white on the #333 slider track, and 6.44:1
       *      between the two bands of the ring itself.
       * ==================================================================== */
      var CSS = [
        '.bno-visually-hidden{position:absolute!important;width:1px!important;height:1px!important;',
        'padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;',
        'clip-path:inset(50%)!important;white-space:nowrap!important;border:0!important;}',

        /* ---- #51 visible labels ---- */
        /* site CSS colours/aligns bare labels inside the widget, so scope + !important */
        '.storeifyapps-storelocator-shortcode .bno-a11y-label,.bno-a11y-label{',
        'display:block!important;font-size:14px!important;line-height:1.3!important;',
        'font-weight:600!important;color:#121212!important;margin:0 0 4px!important;',
        'padding:0!important;float:none!important;width:auto!important;',
        'text-align:left!important;text-decoration:none!important;text-transform:none!important;}',
        '.storeifyapps-storelocator-shortcode .search-address-box{display:grid;',
        'grid-template-columns:auto minmax(0,1fr);gap:0 10px;align-items:start;}',
        '.storeifyapps-storelocator-shortcode .search-address-box>*{float:none!important;',
        'width:auto!important;margin-left:0!important;margin-right:0!important;}',
        '.storeifyapps-storelocator-shortcode .bno-field{min-width:0;}',
        '.storeifyapps-storelocator-shortcode .bno-field select{width:100%;}',
        '.storeifyapps-storelocator-shortcode .bno-field[hidden]{display:none!important;}',

        /* ---- #57 + #58 dual-tone focus ring ---- */
        '.storeifyapps-storelocator-shortcode select:focus-visible,',
        '.storeifyapps-storelocator-shortcode input:focus-visible,',
        '.storeifyapps-storelocator-shortcode button:focus-visible,',
        '.storeifyapps-storelocator-shortcode a:focus-visible,',
        '.storeifyapps-storelocator-shortcode [tabindex]:focus-visible,',
        '.gm-style-cc a:focus-visible,.gm-style-cc button:focus-visible{',
        'outline:3px solid transparent!important;',   /* Windows High Contrast */
        'outline-offset:2px!important;',
        'box-shadow:0 0 0 2px #FFFFFF,0 0 0 5px #0A58CA,0 0 0 7px #FFFFFF!important;',
        'border-radius:2px;position:relative;z-index:5;}',

        /* keep the ring off mouse users, but never remove it for keyboard */
        '.storeifyapps-storelocator-shortcode :focus:not(:focus-visible){box-shadow:none;}',

        /* browsers without :focus-visible support */
        '@supports not selector(:focus-visible){',
        '.storeifyapps-storelocator-shortcode select:focus,',
        '.storeifyapps-storelocator-shortcode input:focus,',
        '.storeifyapps-storelocator-shortcode button:focus,',
        '.gm-style-cc a:focus,.gm-style-cc button:focus{',
        'outline:3px solid #0A58CA!important;outline-offset:2px!important;}}',

        /* range input thumb needs its own ring (#57 "progress bar") */
        '.storeifyapps-storelocator-shortcode input[type="range"]:focus-visible::-webkit-slider-thumb{',
        'box-shadow:0 0 0 2px #FFFFFF,0 0 0 5px #0A58CA,0 0 0 7px #FFFFFF;}',
        '.storeifyapps-storelocator-shortcode input[type="range"]:focus-visible::-moz-range-thumb{',
        'box-shadow:0 0 0 2px #FFFFFF,0 0 0 5px #0A58CA,0 0 0 7px #FFFFFF;}',

        /* ---- #54 make map "Terms" / "Keyboard shortcuts" look interactive ---- */
        '.gm-style-cc a,.gm-style-cc button{',
        'text-decoration:underline!important;text-underline-offset:2px!important;',
        'text-decoration-thickness:1px!important;cursor:pointer!important;}',
        '.gm-style-cc a:hover,.gm-style-cc button:hover{',
        'text-decoration-thickness:2px!important;background:#FFFFFF!important;color:#0A58CA!important;}',

        /* ---- #60 required-field instructions ---- */
        '.bno-required-note{display:block;font-size:15px;line-height:1.5;color:#121212;',
        'margin:0 0 1rem;}',
        '.bno-required-note .bno-star{color:#B3261E;font-weight:700;}',

        /* ---- #25 Reflow at 400% zoom (= a 320 CSS px viewport) ---- */

        /* a) Hidden labels must not rely on the deprecated `clip` alone.
              base.css has `.header__icon span{height:100%}`, which beats
              `.visually-hidden{height:1px}` on specificity and stretches the
              "Log in" / "Cart" labels into a 1x145px box (1x426px on mobile)
              sitting directly over the header icons. The moment anything
              neutralises `clip` the text paints. `:not(:focus...)` keeps the
              skip-to-content link free to reveal itself. */
        '.visually-hidden:not(:focus):not(:focus-within):not(:active){',
        'clip-path:inset(50%)!important;white-space:nowrap!important;',
        'overflow:hidden!important;}',
        '.header__icon span.visually-hidden{width:1px!important;height:1px!important;}',

        '@media screen and (max-width:749px){',
        /* b) The banner had a fixed 280px height with object-fit:cover, so it
              cropped ~26% of the image at 406px and ~42% at 320px - and the
              product names are baked into the artwork. Honour the image's own
              ratio instead; --bno-banner-ratio is set from the img attrs. */
        '.banner{height:auto!important;aspect-ratio:var(--bno-banner-ratio,16/9);}',
        '.banner__content{min-height:0!important;}',
        '.banner__media{height:100%!important;}',
        '.banner__media img{width:100%!important;height:100%!important;}',

        /* c) The floating hCaptcha badge is position:fixed, 223px wide and
              parked past the right edge - at 320px it and its Privacy /
              Terms links are 167px outside the viewport and unreachable.
              Hidden here and replaced with the in-flow disclosure below,
              which is hCaptcha's documented alternative to the badge. */
        '#shop-hcaptcha-badge-container{display:none!important;}',

        /* d) nothing else may exceed the viewport width */
        '.search__input,.field__input{max-width:100%!important;}',
        '}',

        '.bno-captcha-notice{display:block;margin:1.2rem 0 0;padding:0 1.5rem 1.5rem;',
        'font-size:1.3rem;line-height:1.5;text-align:center;opacity:.85;}',
        '.bno-captcha-notice a{color:inherit;text-decoration:underline;',
        'text-underline-offset:2px;}',

        /* ---- #68 table captions ---- */
        '.bno-table-caption{caption-side:top;text-align:left;font-weight:600;',
        'padding:0 0 .6rem;line-height:1.4;}',

        /* ---- #69 the scroll regions now take focus, so show it ---- */
        '#accessiblyAppDialog [role="region"]:focus-visible{',
        'outline:3px solid #0A58CA!important;outline-offset:-3px!important;}',

        /* ---- #71 Text Spacing: the panel header was a nowrap flex row with
           a fixed-width title, so 0.12em letter-spacing pushed the title
           under the EN and Close buttons. Let it wrap and shrink. ---- */
        '#accessiblyAppDialog .accessibly-app-navigation{flex-wrap:wrap!important;',
        'align-items:center!important;row-gap:6px!important;column-gap:10px!important;',
        'padding-right:8px!important;}',
        '#accessiblyAppDialog .accessibly-app-navigation>*{min-width:0!important;}',
        '#accessiblyAppDialog #accessiblyAppDialogTitle{white-space:normal!important;',
        'overflow-wrap:anywhere!important;min-width:0!important;left:auto!important;}'
      ].join('');

      $('<style id="bno-a11y-css">').text(CSS).appendTo('head');

      /* ==================================================================== *
       * ISSUE #51 - WCAG 3.3.2  Visible labels for the store-locator fields
       * ==================================================================== */
      /* Attach a VISIBLE label to a field.
         The Storeify app renders the locator twice (inline + hidden modal),
         which duplicates ids such as #address. A <label for> can only bind to
         the first match, so when the id is not unique we emit a <span> and
         bind it with aria-labelledby instead - visible text either way.      */
      var uid = 0;
      function labelField($field, text, $insertBefore) {
        if (!$field.length || $field.data('bnoLabelled')) { return; }
        $field.data('bnoLabelled', true);

        var id = $field.attr('id');
        var unique = id && $('[id="' + id + '"]').length === 1;
        var $label;

        if (unique) {
          $label = $('<label class="bno-a11y-label">').attr('for', id).text(text);
        } else {
          var lid = 'bno-lbl-' + (++uid);
          $label = $('<span class="bno-a11y-label">').attr('id', lid).text(text);
          $field.attr('aria-labelledby', lid);
        }
        ($insertBefore && $insertBefore.length ? $insertBefore : $field).before($label);
        return $label;
      }

      function addVisibleLabels() {
        $('.storeifyapps-storelocator-shortcode').each(function () {
          var $root = $(this);
          var $box  = $root.find('.search-address-box').first();
          if (!$box.length || $box.data('bnoDone')) { return; }
          $box.data('bnoDone', true);

          /* 1. "Location / Store name" <select> - shipped with no id, no label */
          var $select = $box.find('select.chose-search-slt').first();
          if ($select.length) {
            /* #53 - the select shipped with no id at all, so JAWS announced it
               as an unnamed combo box. A unique id lets labelField() use a real
               <label for>, which is what the finding asks for. */
            if (!$select.attr('id')) { $select.attr('id', 'bno-search-type-' + (++uid)); }
            $select.wrap('<div class="bno-field bno-field--type"></div>');
            labelField($select, 'Search by');
          }

          /* 2. Address input - only had placeholder "Type to search our stores" */
          var $addr = $box.find('input[name="address"]').first();
          if ($addr.length) {
            labelField($addr, 'Search our stores');
          }

          /* 3. Store-name input (shown when "Store name" is selected) --------- */
          var $store = $box.find('input[name="store_search"]').first();
          if ($store.length) {
            $store.wrap('<div class="bno-field bno-field--store"></div>');
            labelField($store, 'Store name');

            /* the app toggles the field with an inline display style - keep the
               visible label in step so it never outlives its field           */
            var $wrap = $store.closest('.bno-field');
            var sync  = function () {
              $wrap.prop('hidden', $store.css('display') === 'none');
            };
            sync();
            if (window.MutationObserver) {
              new MutationObserver(sync).observe($store[0], {
                attributes: true, attributeFilter: ['style', 'class']
              });
            }
            $root.on('change', 'select.chose-search-slt', function () {
              setTimeout(sync, 50);
            });
          }

          /* 4. Radius slider - a <label> existed but was never associated ----- */
          var $radius = $root.find('input[name="points"]').first();
          if ($radius.length && !$radius.data('bnoRadius')) {
            $radius.data('bnoRadius', true);
            var rid = $radius.attr('id');
            var $rl = $radius.closest('.search-radius-box').find('label').first();
            if ($rl.length && !$rl.attr('for') && rid && $('[id="' + rid + '"]').length === 1) {
              $rl.attr('for', rid);
            }
            $radius.attr('aria-valuetext', $radius.val() + ' miles')
                   .on('input change', function () {
                     $(this).attr('aria-valuetext', this.value + ' miles');
                   });
            if (!$radius.attr('aria-label') && !$rl.attr('for')) {
              $radius.attr('aria-label', 'Search radius in miles');
            }
          }
        });
      }

      /* ==================================================================== *
       * ISSUE #54 - WCAG 1.4.1  "Terms" / "Keyboard shortcuts" distinction
       * The CSS above does the styling; Google re-renders these controls on
       * map init / resize, so re-assert nothing is needed for CSS, but we do
       * give the controls a proper accessible name where one is missing.
       * ==================================================================== */
      function fixMapControls() {
        $('.gm-style-cc').find('a, button').each(function () {
          var $c = $(this);
          var txt = $.trim($c.text());
          if (txt && !$c.attr('aria-label')) { $c.attr('aria-label', txt); }
          /* links that open a new tab should say so */
          if (this.tagName === 'A' && $c.attr('target') === '_blank' &&
              $c.find('.bno-visually-hidden').length === 0) {
            $c.append('<span class="bno-visually-hidden"> (opens in a new tab)</span>');
          }
        });

        /* ---- #52 + #55 --------------------------------------------------
           Google renders TWO buttons named "Keyboard shortcuts": the visible
           one in the attribution bar, and a 0x0 duplicate that sits BEFORE
           the map container in the DOM. That duplicate is why the control is
           announced twice and why Tab reaches "Keyboard shortcuts" before the
           map frame. Take the zero-size copy out of the tab order and out of
           the accessibility tree; the visible one keeps working.          */
        $('#map, .gm-style').find('button[aria-label]').each(function () {
          var $b = $(this);
          if ($b.data('bnoDup')) { return; }
          var label = $b.attr('aria-label');
          var r = this.getBoundingClientRect();
          if (r.width > 0 || r.height > 0) { return; }

          /* only when a *visible* control already carries the same name */
          var dup = $('#map, .gm-style').find('button[aria-label="' + label + '"]')
            .filter(function () {
              var rr = this.getBoundingClientRect();
              return rr.width > 0 && rr.height > 0;
            }).length;
          if (!dup) { return; }

          $b.data('bnoDup', true)
            .attr({ 'tabindex': '-1', 'aria-hidden': 'true' });
        });

        /* ---- #52 --------------------------------------------------------
           A title identical to the accessible name is read a second time as
           the description. Drop the title, keep the name.                 */
        $('#map, .gm-style').find('[title]').each(function () {
          var $c = $(this);
          var t = $.trim($c.attr('title'));
          var name = $.trim($c.attr('aria-label') || $c.text());
          if (t && name && t.toLowerCase() === name.toLowerCase()) {
            $c.removeAttr('title');
          }
        });
      }

      /* ==================================================================== *
       * ISSUE #56 - WCAG 2.4.4  Raw URL as the link text in the store list
       * ==================================================================== */
      // function fixStoreWebsiteLinks() {
      //   $('a.storeify-storelocator-web').each(function () {
      //     var $a = $(this);
      //     if ($a.data('bnoLink')) { return; }
      //     var txt = $.trim($a.text());
      //     if (!/^https?:\/\//i.test(txt)) { return; }
      //     $a.data('bnoLink', true);

      //     var name = $.trim($a.closest('.item, .inner-item, li').find('.store-name').first().text());
      //     if (!name) { name = describeUrl($a.attr('href')) || 'Store'; }
      //     $a.text(name + ' website');
      //   });
      // }

      function fixStoreWebsiteLinks() {
        $('a.storeify-storelocator-web').each(function () {

        var $a = $(this);

        if ($a.data('bnoLink')) {
            return;
        }

        var txt = $.trim($a.text());

        if (!/^https?:\/\//i.test(txt)) {
            return;
        }

        $a.data('bnoLink', true);

        var name = $.trim(
            $a.closest('.item, .inner-item, li')
              .find('.store-name')
              .first()
              .text()
        );

        if (!name) {
            name = describeUrl($a.attr('href')) || 'Store';
        }

        // Keep the visible URL text unchanged
        // Add a descriptive accessible name instead
        $a.attr('aria-label', name + ' website');
       });
      }

      /* ==================================================================== *
       * ISSUE #57 / #58 - Focus visibility + contrast
       * Handled by the stylesheet. Here we only make sure every locator
       * control is actually reachable and not focus-trapped by tabindex="-1".
       * ==================================================================== */
      function fixFocusability() {
        $('.storeifyapps-storelocator-shortcode')
          .find('#submit-search, #getbylocal, #btn-filter, .map-tab-mobile-bnt-item')
          .each(function () {
            var $el = $(this);
            if (this.tagName === 'DIV') {          /* app uses <div> as buttons */
              if (!$el.attr('role'))     { $el.attr('role', 'button'); }
              if (!$el.attr('tabindex')) { $el.attr('tabindex', '0'); }
              if (!$el.data('bnoKeys')) {
                $el.data('bnoKeys', true).on('keydown', function (e) {
                  if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                    e.preventDefault();
                    $(this).trigger('click');
                  }
                });
              }
            }
            if ($el.attr('tabindex') === '-1') { $el.attr('tabindex', '0'); }
          });
      }

      /* ==================================================================== *
       * BONUS - icon ligatures were part of the accessible name
       * The locator buttons render Material Icons as text ("travel_explore
       * Search"), so JAWS announced the ligature. Hide the glyph from AT and
       * fall back to the button's own title when nothing readable is left.
       * ==================================================================== */
      function fixIconButtons() {
        $('.storeifyapps-storelocator-shortcode')
          .find('.material-icons, .material-icons-outlined')
          .attr('aria-hidden', 'true');

        $('.storeifyapps-storelocator-shortcode').find('button, [role="button"]').each(function () {
          var $b = $(this);
          var visible = $.trim($b.clone().find('[aria-hidden="true"]').remove().end().text());
          if (!visible && !$b.attr('aria-label')) {
            $b.attr('aria-label', $b.attr('title') || 'Button');
          }
        });
      }

      /* ==================================================================== *
       * ISSUE #60 - WCAG 3.3.2  Required-field instructions (Contact form)
       * Also applied to any Shopify form that uses "*" in its labels
       * (contact, login, "Continue with Shop" email step).
       * ==================================================================== */
      // function addRequiredInstructions() {
      //   $('form').each(function () {
      //     var $form = $(this);
      //     if ($form.data('bnoReq')) { return; }

      //     /* find labels whose visible text ends with an asterisk */
      //     var $starLabels = $form.find('label').filter(function () {
      //       return /\*\s*$/.test($(this).text());
      //     });
      //     if (!$starLabels.length) { return; }
      //     $form.data('bnoReq', true);

      //     /* 1. visible instruction, announced before the first field -------- */
      //     var noteId = 'bno-required-note-' + ($form.attr('id') || Math.random().toString(36).slice(2, 7));
      //     var $note = $('<p class="bno-required-note">')
      //       .attr('id', noteId)
      //       .html('Fields marked with an asterisk ' +
      //             '<span class="bno-star" aria-hidden="true">(*)</span> are required.');

      //     /* put the instruction ABOVE the very first field of the form, so it
      //        is read before the user reaches any control (3.3.2)            */
      //     var $anchor = $form.find('.field, .form__group, .contact__fields').first();
      //     if (!$anchor.length) {
      //       $anchor = $form.find('input:not([type=hidden]),select,textarea').first()
      //                      .closest('div');
      //     }
      //     if ($anchor.length) { $note.insertBefore($anchor); }
      //     else { $form.prepend($note); }

      //     /* 2. programmatic required state + description -------------------- */
      //     $starLabels.each(function () {
      //       var $lab = $(this);
      //       var id = $lab.attr('for');
      //       var $field = id ? $('#' + window.CSS.escape(id)) : $lab.find('input,select,textarea').first();
      //       if (!$field.length) { return; }

      //       $field.attr({ 'required': 'required', 'aria-required': 'true' });

      //       var desc = ($field.attr('aria-describedby') || '').split(/\s+/).filter(Boolean);
      //       if (desc.indexOf(noteId) === -1) { desc.push(noteId); }
      //       $field.attr('aria-describedby', desc.join(' '));

      //       /* 3. the asterisk must not be the only cue in the accessible name.
      //             Dawn already wraps it in aria-hidden, so only add the spoken
      //             word; a bare "*" gets wrapped as well.                      */
      //       if (!$lab.data('bnoStar')) {
      //         $lab.data('bnoStar', true);
      //         var html = $lab.html();
      //         if (/\*(\s*)$/.test(html)) {
      //           $lab.html(html.replace(
      //             /\*(\s*)$/,
      //             '<span class="bno-star" aria-hidden="true">*</span>' +
      //             '<span class="bno-visually-hidden"> (required)</span>$1'
      //           ));
      //         } else if (!$lab.find('.bno-visually-hidden').length) {
      //           $lab.append('<span class="bno-visually-hidden"> (required)</span>');
      //         }
      //       }
      //     });
      //   });
      // }

      /* ==================================================================== *
       * ISSUE #25 - WCAG 1.4.10 Reflow
       * The stylesheet above does the layout work. Two things need JS:
       * the banner's real aspect ratio, and an in-flow replacement for the
       * hCaptcha badge that is hidden on narrow viewports.
       * ==================================================================== */
      function fixBannerRatio() {
        $('.banner').each(function () {
          var $b = $(this);
          if ($b.data('bnoRatio')) { return; }
          var img = $b.find('.banner__media img')[0];
          if (!img) { return; }
          var w = parseFloat(img.getAttribute('width'))  || img.naturalWidth;
          var h = parseFloat(img.getAttribute('height')) || img.naturalHeight;
          if (!w || !h) { return; }
          $b.data('bnoRatio', true);
          $b[0].style.setProperty('--bno-banner-ratio', w + ' / ' + h);
        });
      }

      // function addCaptchaNotice() {
      //   if ($('.bno-captcha-notice').length) { return; }
      //   /* Shopify loads the badge lazily, so key off the forms hCaptcha
      //      actually protects (newsletter, contact, account) - or the badge
      //      itself once it appears. Never claim protection otherwise. */
      //   var protectedForm = $('form[action*="/contact"], form[action*="/account"], form[action*="/comments"]').length;
      //   if (!protectedForm && !document.getElementById('shop-hcaptcha-badge-container')) { return; }

      //   var $host = $('.footer__content-bottom').first();
      //   if (!$host.length) { $host = $('.footer').first(); }
      //   if (!$host.length) { return; }

      //   $host.append(
      //     '<p class="bno-captcha-notice">This site is protected by hCaptcha and its ' +
      //     '<a href="https://hcaptcha.com/privacy" target="_blank" rel="noopener">Privacy Policy' +
      //     '<span class="bno-visually-hidden"> (opens in a new tab)</span></a> and ' +
      //     '<a href="https://hcaptcha.com/terms" target="_blank" rel="noopener">Terms of Service' +
      //     '<span class="bno-visually-hidden"> (opens in a new tab)</span></a> apply.</p>'
      //   );
      // }


      /* ==================================================================== *
       * ISSUES #59 / #65 - every page needs one level-one heading
       * ==================================================================== */
      function ensureH1() {
        if ($('h1, [role="heading"][aria-level="1"]').length) { return; }

        var $scope = $('#MainContent').length ? $('#MainContent') : $('main');
        if (!$scope.length) { return; }

        /* the first real, visible heading in the main region is the page title */
        var $h = $scope.find('h2, h3').filter(function () {
          var $t = $(this);
          return !$t.hasClass('visually-hidden') &&
                 $.trim($t.text()).length > 0 &&
                 $t.is(':visible');
        }).first();
        if (!$h.length) { return; }

        var el  = $h[0];
        var h1  = document.createElement('h1');
        for (var i = 0; i < el.attributes.length; i++) {
          h1.setAttribute(el.attributes[i].name, el.attributes[i].value);
        }
        h1.innerHTML = el.innerHTML;
        el.parentNode.replaceChild(h1, el);
      }

      /* ==================================================================== *
       * ISSUE #64 - the visually hidden "Contact form" heading is redundant
       * ==================================================================== */
      function dropRedundantHeadings() {
        $('h1, h2, h3, h4, h5, h6').filter('.visually-hidden').each(function () {
          var $h = $(this);
          var t  = $.trim($h.text()).toLowerCase();
          if (t === 'contact form' || t === 'form') { $h.remove(); }
        });
      }

      /* ==================================================================== *
       * ISSUES #61 / #62 / #63 - form validation and status messages
       * Shopify renders these server-side, so they are already in the DOM at
       * load time. That matters: a live region added after the fact is not
       * announced, which is why #63 also moves focus to the message.
       * ==================================================================== */
      function fixFormMessages() {

        /* ---- #62 - one error does not need a list ---- */
        // $('.form-status-list').each(function () {
        //   var $list = $(this);
        //   if ($list.data('bnoList')) { return; }
        //   $list.data('bnoList', true);

        //   var $items = $list.children('li');
        //   if ($items.length !== 1) { return; }          /* real lists stay lists */

        //   var $p = $('<p>')
        //     .attr('class', $list.attr('class') || '')
        //     .html($items.first().html());
        //   $list.replaceWith($p);
        // });

        /* ---- #61 - send focus to the field that actually failed ---- */
        // $('form').each(function () {
        //   var $form = $(this);
        //   if ($form.data('bnoErrFocus')) { return; }

        //   var $bad = $form.find('[aria-invalid="true"], .field--with-error .field__input')
        //                   .filter(':visible').first();

        //   /* no summary means no failed submit - do not steal focus */
        //   var hasSummary = $form.find('.form-status-list, .form__message[role="alert"]').length ||
        //                    $form.prev('.form__message').length;
        //   if (!$bad.length || !hasSummary) { return; }
        //   $form.data('bnoErrFocus', true);

        //   /* tie the message to the field if the theme has not already */
        //   var $msg = $bad.closest('.field').find('.contact__field-error, .form__message').first();
        //   if ($msg.length) {
        //     if (!$msg.attr('id')) { $msg.attr('id', 'bno-err-' + ($bad.attr('id') || 'field')); }
        //     var d = ($bad.attr('aria-describedby') || '').split(/\s+/).filter(Boolean);
        //     if (d.indexOf($msg.attr('id')) === -1) { d.push($msg.attr('id')); }
        //     $bad.attr({ 'aria-describedby': d.join(' '), 'aria-invalid': 'true' });
        //   }

        //   setTimeout(function () { $bad.trigger('focus'); }, 100);
        // });

        /* ---- #63 - announce the success message ---- */
        // $('.form-status').not('.form-status-list').each(function () {
        //   var $s = $(this);
        //   if ($s.data('bnoStatus')) { return; }
        //   /* skip the error heading - that path is handled above */
        //   if ($s.closest('form').find('[aria-invalid="true"]').length) { return; }
        //   $s.data('bnoStatus', true);

        //   $s.attr({ 'role': 'status', 'aria-live': 'polite', 'tabindex': '-1' });
        //   setTimeout(function () { $s.trigger('focus'); }, 150);
        // });
      }

      /* ==================================================================== *
       * ISSUE #68 - policy tables have no caption and no scoped headers
       * ==================================================================== */
      function fixPolicyTables() {
        var $scope = $('#MainContent').length ? $('#MainContent') : $('main');
        $scope.find('table').each(function () {
          var $t = $(this);
          if ($t.data('bnoTable')) { return; }
          $t.data('bnoTable', true);

          var $rows = $t.find('tr');
          $rows.first().children('th').attr('scope', 'col');
          $rows.slice(1).each(function () {
            var $first = $(this).children().first();
            if ($first.is('th')) { $first.attr('scope', 'row'); }
          });

          if ($t.children('caption').length) { return; }

          /* the sentence that introduces the table is the caption */
          var text = '';
          var $intro = $t.prevAll('p, h2, h3, h4').filter(function () {
            return $.trim($(this).text()).length > 20;
          }).first();
          if ($intro.length) {
            text = $.trim($intro.text()).replace(/\s+/g, ' ');
            var stop = text.indexOf('. ');
            if (stop > 20) { text = text.slice(0, stop + 1); }
            if (text.length > 140) { text = text.slice(0, 137).replace(/\s+\S*$/, '') + '...'; }
          }
          if (!text) { text = 'Data table'; }

          $t.prepend($('<caption class="bno-table-caption">').text(text));
        });
      }

      /* ==================================================================== *
       * ISSUES #69 / #70 - the Accessibly App panel
       * Third-party markup, so everything here is defensive: it only acts on
       * elements that are actually present and never assumes a structure.
       * ==================================================================== */
      var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), ' +
                      'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

      function fixA11yPanel() {
        var dialog = document.getElementById('accessiblyAppDialog');
        if (!dialog) { return; }
        var $dialog = $(dialog);

        /* ---- #69 - a scrollable region must be reachable by keyboard ---- */
        $dialog.find('*').each(function () {
          var el = this;
          if (el.getAttribute('tabindex') !== null) { return; }
          var oy = window.getComputedStyle(el).overflowY;
          if (!/auto|scroll/.test(oy)) { return; }
          if (el.scrollHeight <= el.clientHeight + 4) { return; }

          var $r = $(el);
          $r.attr({ 'tabindex': '0', 'role': 'region' });
          if (!$r.attr('aria-label')) {
            var name = $.trim($('#accessiblyAppDialogTitle').text()) || 'Panel';
            $r.attr('aria-label', name + ' (scrollable)');
          }
        });

        /* ---- #71 - the title's wrapper is flex:0 1 50%, so the title had to
             overflow it. There is no class to hook, so widen it here. ---- */
        var titleEl = document.getElementById('accessiblyAppDialogTitle');
        if (titleEl && titleEl.parentElement) {
          titleEl.parentElement.style.setProperty('flex', '1 1 auto', 'important');
          titleEl.parentElement.style.setProperty('min-width', '0', 'important');
        }

        /* ---- #70 - focus the first control when the dialog opens ---- */
        if (!$dialog.data('bnoDialog')) {
          $dialog.data('bnoDialog', true);

          var focusFirst = function () {
            if (!$dialog.is(':visible')) { return; }
            /* the widget parks focus on the dialog container itself, which is
               focusable but not interactive - move on from it, but never
               steal focus that is already on a real control */
            var act = document.activeElement;
            if (dialog.contains(act) && act.matches && act.matches(FOCUSABLE)) { return; }
            var $f = $dialog.find(FOCUSABLE).filter(':visible').first();
            if ($f.length) { $f.trigger('focus'); }
          };

          /* The widget opens the panel by swapping a stylesheet rule, not by
             changing the dialog's own class or style, so there is no mutation
             to observe. Watch the rendered state instead, and react to clicks
             on the launcher for a faster path. */
          var wasOpen = $dialog.is(':visible');
          setInterval(function () {
            var open = $dialog.is(':visible');
            if (open && !wasOpen) { fixA11yPanel(); setTimeout(focusFirst, 120); }
            wasOpen = open;
          }, 400);

          $(document).on('click', '.accessibly-app-widget-button, #accessiblyAppDialog', function () {
            setTimeout(function () { fixA11yPanel(); focusFirst(); }, 150);
          });

          if (wasOpen) { setTimeout(focusFirst, 120); }

          /* keep Tab inside the dialog while it is modal */
          $dialog.on('keydown', function (e) {
            if (e.key !== 'Tab') { return; }
            var $f = $dialog.find(FOCUSABLE).filter(':visible');
            if (!$f.length) { return; }
            var first = $f[0], last = $f[$f.length - 1];
            if (e.shiftKey && document.activeElement === first) {
              e.preventDefault(); last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
              e.preventDefault(); first.focus();
            }
          });
        }
      }

      /* ==================================================================== *
       * Run now, and again as the Storeify app / Google Maps finish painting
       * ==================================================================== */
      function runAll() {
        try { addVisibleLabels(); }        catch (e) { }
        try { fixMapControls(); }          catch (e) { }
        try { fixFocusability(); }         catch (e) { }
        try { fixIconButtons(); }          catch (e) { }
        // try { addRequiredInstructions(); } catch (e) { }
        try { fixBannerRatio(); }          catch (e) { }
        // try { addCaptchaNotice(); }        catch (e) { }
        try { fixStoreWebsiteLinks(); }    catch (e) { }
        try { ensureH1(); }                catch (e) { }
        try { dropRedundantHeadings(); }   catch (e) { }
        try { fixFormMessages(); }         catch (e) { }
        try { fixPolicyTables(); }         catch (e) { }
        try { fixA11yPanel(); }            catch (e) { }
      }

      runAll();
      [300, 800, 1500, 3000, 5000].forEach(function (t) { setTimeout(runAll, t); });

      if (window.MutationObserver) {
        var pending;
        new MutationObserver(function () {
          clearTimeout(pending);
          pending = setTimeout(runAll, 250);
        }).observe(document.body, { childList: true, subtree: true });
      }
    });
  }

  boot();
})();





